const synth = (): SpeechSynthesis | null => (typeof speechSynthesis === "undefined" ? null : speechSynthesis);

const tag = (voice: SpeechSynthesisVoice): string => voice.lang.replace(/_/g, "-").toLowerCase();

// TODO: Exclude non-Mandarin zh extlangs; zh-wuu and zh-hak currently pass this filter.
export const mandarin = (voice: SpeechSynthesisVoice): boolean => /^(zh|cmn)\b/.test(tag(voice)) && !/-(hk|mo)\b|yue/.test(tag(voice));

export function chineseVoice(s: SpeechSynthesis): SpeechSynthesisVoice | null {
  const voices = s.getVoices().filter(mandarin);
  return voices.find((v) => /-(hans-)?cn\b/.test(tag(v))) ?? voices[0] ?? null;
}

export function speak(text: string, slow = false): void {
  const s = synth();
  if (!s) return;
  if (s.speaking || s.pending) s.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "zh-CN";
  utterance.voice = chineseVoice(s);
  if (slow) utterance.rate = 0.4;
  // TODO: Surface utterance errors except canceled/interrupted; network or unavailable-voice failures currently leave Play silent.
  s.speak(utterance);
}

export function hush(): void {
  synth()?.cancel();
}

export function watchVoices(set: (available: boolean) => void): () => void {
  const s = synth();
  if (!s) {
    set(false);
    return () => {};
  }
  const report = () => set(chineseVoice(s) !== null);
  report();
  s.addEventListener("voiceschanged", report);
  return () => s.removeEventListener("voiceschanged", report);
}
